import styled from 'styled-components';
import { FaInstagram, FaFacebookSquare, FaYoutube } from "react-icons/fa";

export const DivPrincipal = styled.div`
  display:flex;
  justify-content:center;
  flex-wrap:wrap;
  width:100vw;
  height:100vh;
  overflow:auto;
  background:#fff;

`;
export const DivElementos = styled.div`
    width:100%;
    @media(max-width:800px){

    }
`
export const TextoBannerTop = styled.h2`
    text-align:center;
    margin:20px 0;
    color:#fff;
    font-family: 'Montserrat', sans-serif;
    :nth-child(1){
        font-size:40px;
        margin-bottom: 60px;
        line-height: 70px;
        width:80%;
    }
    :nth-child(2){
        margin:0 0 20px 0;
    }
    @media(max-width:800px){
        :nth-child(1){
        font-size:25px;
        margin-bottom: 60px;
        line-height: 40px;
        width:80%;
        }
        :nth-child(2){
            font-size:20px;
            margin:0 0 40px 0;
        }
    }
`
export const DivAcesso = styled.div`
    width:100%;
    display:flex;
    justify-content:space-between;
    align-items:center;
    padding:10px 30px;
    margin-bottom:25px;
    >div{
        >img{
            width:135px;
        }
    }


`
export const DivButtonAcessar = styled.div`

    @media(max-width:800px){
        width:unset;
    }
`
export const Button = styled.button`
    /* color: linear-gradient(to right top, #1a97a7, #299aa8, #359daa, #3e9fab, #47a2ad); */
    box-shadow:inset 0px 1px 0px 0px #3f81b8;
	background:linear-gradient(to bottom, #3379b7 5%, #3379b7 100%);
	background-color:#3379b7;
	border:1px solid #3f81b8;
	display:inline-block;
	cursor:pointer;
	color:#ffffff;
	font-family:Arial;
	font-size:18px;
	font-weight:bold;
	padding:6px 12px;
    text-decoration:none;
    height:${props => props.height};
    width:${props => props.width};
    :hover {
	background:linear-gradient(to bottom, #3379b7 5%, #3379b7 100%);
	background-color:#3379b7;
    }
    :active {
	position:relative;
	top:1px;
    }

    `
export const DivTop = styled.div`
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background:#fff;
        height:550px;
        position:relative;
        >img{
            width:40%;
            min-width:350px;
        }
        @media(max-width:800px){
            height:unset;
        }
    `
export const DivImageTextoBannerTop = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    width:100%;
    height:100%;
    @media(max-width:800px){
        flex-direction:column;
        >img{

          width:350px;
        }

    }

`
export const DivCorpo = styled.div`
        display:flex;
        margin:30px 0;
        padding:0 40px 20px 40px;
        flex-wrap:wrap;
        flex-direction:${props => props.inverter ? 'row-reverse' : 'row'};
        >div{
            width:50%;
            display:flex;
            flex-direction:column;
            justify-content:center;
            align-items:center;
            text-align:center;
            >img{
                max-width:450px;
                width:100%;
            }
            >h2{
                font-size:25px;
                font-weight: 600;
                font-style: normal;
                margin-bottom: 20px;
            }
            >p{
                font-size: 18px;
                width:70%;
            }
            @media(max-width:800px){
                width:100%;
                margin:10px 0;
                >p{
                    width:100%;
                }
            }
        }

    `
export const DivPreco = styled.div`
        display:flex;
        flex-direction:column;
        justify-content:center;
        align-items:center;
        text-align:center;
        padding: 0 40px 0 40px;
        >img{
            width:700px;
        }
        >div{
            >h3{
                font-size:40px;
                margin-bottom:20px;
            }
            >h2{
                font-size:30px;
                margin:20px 0;
            }
            >p{
                font-size:22px;
            }
            >span{
                font-size:12pt;
            }
        }
        >a>button{
            margin:30px 0 10px;
        }

    `
export const IconFaInstagram = styled(FaInstagram)`
    width:32px;
    height:32px;
    color:#fff;
`
export const IconFaFacebookSquare = styled(FaFacebookSquare)`
    width:32px;
    height:32px;
    color:#fff;
`
export const IconFaYoutube = styled(FaYoutube)`
    width:32px;
    height:32px;
    color:#fff;
`
export const DivRodape = styled.div`
    width:100vw;
    background:#1B1B1B;
    color:#fff;

`
export const CorpoRodape = styled.div`
    max-width: 1024px;
    margin: auto;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    text-align: justify;
    padding: 20px 0;
    flex-wrap:wrap;
    >div{
        width:50%;
        padding:20px;
        >h1{
            margin-bottom:10px;
        }
        @media(max-width:800px){
            width: 100%;
        }

    }
   >div:nth-child(2){
       text-align:center;
   }
   @media(max-width:800px){
       flex-direction:row;
       flex-wrap:wrap;
   }
`
export const DivRedeSocial = styled.div`
    margin:0 20px;
`
export const RedesSociais = styled.div`
    display:flex;
    justify-content:center;
`
export const CopyRigth = styled.div`
    width:100%!important;
    text-align:center;
    margin:20px 0;
    color:#337AA6;
    height:fit-content;

`
export const DivImgMobile = styled.div`
    >img{
    display:none;
    @media(max-width:800px){
        max-width:450px;
        width:100%;
        margin-bottom:20px;
        display:block;
    }
        }

`
export const DivExperimente = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    margin:25px 0;
    >h2{
        margin:0 80px 0 0;
    }
    @media(max-width:800px){
        flex-direction:column;
        padding:0 40px 0 40px;
        text-align:center;
        >h2{
            margin:0 0 20px 0;
            margin-right:0;

        }
    }
`
